import { render } from "./camerascanView.vue?vue&type=template&id=37c4f705"
import script from "./camerascanView.vue?vue&type=script&lang=js"
export * from "./camerascanView.vue?vue&type=script&lang=js"

import "./camerascanView.vue?vue&type=style&index=0&id=37c4f705&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__